import { configureStore } from "@reduxjs/toolkit";

import coachReducer from "./features/coach";
import adminReducer from "./features/admin";
import findAJobReducer from "./features/find-a-job";
import hireTalentReducer from "./features/hire-talent";
import chatReducer from "./features/chat";

export const store = configureStore({
  reducer: {
    coach: coachReducer,
    admin: adminReducer,
    freelancer: findAJobReducer,
    hireTalent: hireTalentReducer,
    chat: chatReducer,
  },
});
